<template>
    <div class="games">
        <template v-if="$store.state.isShow590">
            <img v-if="!$store.state.isScreenMobile" :src="require(`@/public/theme/${themePath}/img/banner/banner.png`)" @error="handleBannerImageError($event, 'banner')" />
            <img v-else :src="require(`@/public/theme/${themePath}/img/banner/banner-mobile.png`)" @error="handleBannerImageError($event, 'banner-mobile')" />
        </template>
        <LoadingScreen v-if="loadingPage" />
        <template v-else>
            <EmptyComponent v-if="dataSource.length === 0" text="no data" />
            <div class="games__list" v-else>
                <div class="games__item" v-for="(v, i) in dataSource" :key="i">
                    <div 
                        v-if="v.banner === 'lotto-6-45' && $store.state.isShow645 || v.banner === 'lotto-5-45'  && $store.state.isShow545 || CT_GAME_SLUG.LOTTO_459.includes(v.banner?.toLowerCase()) && $store.state.isShow459" 
                        class="games__games-item-banner" 
                    >
                        <img v-if="!$store.state.isScreenMobile" :src="require(`@/public/theme/${themePath}/img/banner/${v.banner}.png`)" @error="handleBannerImageError($event, v.banner)" />
                        <img v-else :src="require(`@/public/theme/${themePath}/img/banner/${v.banner}-mobile.png`)" @error="handleBannerImageError($event, v.banner + '-mobile')" />
                    </div>
                    <div class="games__item-header">
                        <span>{{ getTranslatedText(`${v.isPariMutuelLotto ? '' : 'loto '}${v.title}`) }}</span>
                    </div>
                    <div class="games__item-list-number">
                        <div class="games__item-item-number" v-for="(value, index) in v.listRanDomNumber" :key="index" @click="onClickGames(v, value, index)">
                            <span v-if="v.isPariMutuelLotto">{{ getTranslatedText('play') }}</span>
                            <span v-else>{{
                                getTranslatedText(`${v.title} [number]`, {
                                    number: value.number,
                                })
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import pathAssetsMixins from '@/mixins/pathAssets/path-assets-mixins'
import languageMixins from '@/mixins/language/language-mixins'
import getListGames from '@/mixins/getListGames/get-list-games-mixin'
import LoadingScreen from '@/components/common/loading/index.vue'
import EmptyComponent from '@/components/common/empty/index.vue'
import routerMixins from '@/mixins/router/router-mixin'
import EventBus from '@/utils/EventBus'
import { isObjEmpty } from '@/utils/utils'
import { CT_GAME_SLUG } from '@/constants/game'

export default {
    mixins: [pathAssetsMixins, languageMixins, getListGames, routerMixins],
    components: { LoadingScreen, EmptyComponent },
    data() {
        return {
            dataSource: [],
            loadingPage: true,
            CT_GAME_SLUG,
            dataBanner: [
                {
                    name: 'isShow645',
                    img: 'banner-645',
                },
                {
                    name: 'isShow459',
                    img: 'banner-459',
                },
                {
                    name: 'isShow545',
                    img: 'banner-645'
                }
            ]
        }
    },
    methods: {
        handleBannerImageError(event, bannerName) {
            const img = event.target;
            const currentSrc = img.src;
            
            // Prevent infinite loop by tracking error attempts
            if (img.dataset.errorAttempted) {
                // Already tried fallback, hide the image
                img.style.display = 'none';
                return;
            }
            
            // Mark that we've attempted error handling
            img.dataset.errorAttempted = 'true';
            
            // Try fallback to default theme
            if (this.themePath !== 'default') {
                try {
                    img.src = require(`@/public/theme/default/img/banner/${bannerName}.png`);
                } catch (e) {
                    // If default theme also fails, hide the image
                    img.style.display = 'none';
                }
            } else {
                // Already on default theme and failed, hide the image
                img.style.display = 'none';
            }
        },
        
        onClickGames(games, itemGame, index) {
            games.listRanDomNumber[index].active = true
            let param = {
                title: games.title,
                gameNumber: itemGame.number,
                name: `${games.name}`,
                price: itemGame?.price || games.price,
                numberQp: games.title === 'turbo' ? 2 : itemGame.number,
                listRanDomNumber: games.listRanDomNumber,
                isPariMutuelLotto: games.isPariMutuelLotto,
                bet_options: games?.bet_options || [],
                jackpot: games.jackpot,
            }

            if(!isObjEmpty(itemGame.allowed_picks)) {
                param['allowed_picks'] = itemGame.allowed_picks
                param['numberQp'] = itemGame.allowed_picks?.max || param['numberQp']
            }
            
            // Add bankers if available
            if(itemGame.bankers && Array.isArray(itemGame.bankers) && itemGame.bankers.length > 0) {
                param['bankers'] = itemGame.bankers
            }

            if (games.isPariMutuelLotto) {
                param['maxPicks'] = games.listRanDomNumber[0].maxPicks
                param['numberQp'] = games.listRanDomNumber[0].number
            }
            
            localStorage.setItem('configGame', JSON.stringify(param))

            if (games.name === 'lotto-6-45') {
                this.routerPush('/games-loto?loto=loto-6-45')
                EventBus.$emit('on-change-active-menu', '/games-loto?loto=loto-6-45')
                this.$store.state.stepCart = 2
            } else if (CT_GAME_SLUG.LOTTO_459.includes(games.name?.toLowerCase())) {
                this.routerPush(`/games-loto?loto=${games.name?.toLowerCase()}`)
                EventBus.$emit('on-change-active-menu', `/games-loto?loto=${games.name?.toLowerCase()}`)
                this.$store.state.stepCart = 3
            } else if (games.name === 'lotto-5-45') {
                this.routerPush('/games-loto?loto=loto-5-45')
                EventBus.$emit('on-change-active-menu', '/games-loto?loto=loto-5-45')
                this.$store.state.stepCart = 4
            } else {
                this.routerPush('/games-loto?loto=loto-5-90')
                this.$store.state.stepCart = 1
                EventBus.$emit('on-change-active-menu', '/games-loto?loto=loto-5-90')
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/games/_list.scss';
</style>
